import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

@Component({
  selector: 'ish-clear-basket',
  templateUrl: './clear-basket.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ModalDialogComponent, TranslateModule],
})
export class ClearBasketComponent {
  private checkoutFacade = inject(CheckoutFacade);

  readonly cssClass = input<string>(undefined);

  clearBasket() {
    this.checkoutFacade.deleteBasketItems();
  }
}
